import { render, staticRenderFns } from "./FormsActionsManager.vue?vue&type=template&id=47abb523"
import script from "./FormsActionsManager.vue?vue&type=script&lang=js"
export * from "./FormsActionsManager.vue?vue&type=script&lang=js"
import style0 from "./FormsActionsManager.vue?vue&type=style&index=0&id=47abb523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports